import FiveStarsIcon from './five-stars.svg';

export { FiveStarsIcon };

import aslanJpgDesktop from './aslan-desktop.jpg';
import aslanWebpDesktop from './aslan-desktop.webp';
import aslanJpgMobile from './aslan-mobile.jpg';
import aslanWebpMobile from './aslan-mobile.webp';

import busterJpgDesktop from './buster-desktop.jpg';
import busterWebpDesktop from './buster-desktop.webp';
import busterJpgMobile from './buster-mobile.jpg';
import busterWebpMobile from './buster-mobile.webp';

import candyJpgDesktop from './candy-desktop.jpg';
import candyWebpDesktop from './candy-desktop.webp';
import candyJpgMobile from './candy-mobile.jpg';
import candyWebpMobile from './candy-mobile.webp';

import charleyJpgDesktop from './charley-desktop.jpg';
import charleyWebpDesktop from './charley-desktop.webp';
import charleyJpgMobile from './charley-mobile.jpg';
import charleyWebpMobile from './charley-mobile.webp';

import duncanJpgDesktop from './duncan-desktop.jpg';
import duncanWebpDesktop from './duncan-desktop.webp';
import duncanJpgMobile from './duncan-mobile.jpg';
import duncanWebpMobile from './duncan-mobile.webp';

import elvisJpgDesktop from './elvis-desktop.jpg';
import elvisWebpDesktop from './elvis-desktop.webp';
import elvisJpgMobile from './elvis-mobile.jpg';
import elvisWebpMobile from './elvis-mobile.webp';

import francisJpgDesktop from './francis-desktop.jpg';
import francisWebpDesktop from './francis-desktop.webp';
import francisJpgMobile from './francis-mobile.jpg';
import francisWebpMobile from './francis-mobile.webp';

import gabiJpgDesktop from './gabi-desktop.jpg';
import gabiWebpDesktop from './gabi-desktop.webp';
import gabiJpgMobile from './gabi-mobile.jpg';
import gabiWebpMobile from './gabi-mobile.webp';

import ghostJpgDesktop from './ghost-desktop.jpg';
import ghostWebpDesktop from './ghost-desktop.webp';
import ghostJpgMobile from './ghost-mobile.jpg';
import ghostWebpMobile from './ghost-mobile.webp';

import gingerJpgDesktop from './ginger-desktop.jpg';
import gingerWebpDesktop from './ginger-desktop.webp';
import gingerJpgMobile from './ginger-mobile.jpg';
import gingerWebpMobile from './ginger-mobile.webp';

import gretaJpgDesktop from './greta-desktop.jpg';
import gretaWebpDesktop from './greta-desktop.webp';
import gretaJpgMobile from './greta-mobile.jpg';
import gretaWebpMobile from './greta-mobile.webp';

import jacJpgDesktop from './jac-desktop.jpg';
import jacWebpDesktop from './jac-desktop.webp';
import jacJpgMobile from './jac-mobile.jpg';
import jacWebpMobile from './jac-mobile.webp';

import jaxJpgDesktop from './jax-desktop.jpg';
import jaxWebpDesktop from './jax-desktop.webp';
import jaxJpgMobile from './jax-mobile.jpg';
import jaxWebpMobile from './jax-mobile.webp';

import kennyJpgDesktop from './kenny-desktop.jpg';
import kennyWebpDesktop from './kenny-desktop.webp';
import kennyJpgMobile from './kenny-mobile.jpg';
import kennyWebpMobile from './kenny-mobile.webp';

import kimberJpgDesktop from './kimber-desktop.jpg';
import kimberWebpDesktop from './kimber-desktop.webp';
import kimberJpgMobile from './kimber-mobile.jpg';
import kimberWebpMobile from './kimber-mobile.webp';

import kodaJpgDesktop from './koda-desktop.jpg';
import kodaWebpDesktop from './koda-desktop.webp';
import kodaJpgMobile from './koda-mobile.jpg';
import kodaWebpMobile from './koda-mobile.webp';

import loki1JpgDesktop from './loki-1-desktop.jpg';
import loki1WebpDesktop from './loki-1-desktop.webp';
import loki1JpgMobile from './loki-1-mobile.jpg';
import loki1WebpMobile from './loki-1-mobile.webp';

import lokiJpgDesktop from './loki-desktop.jpg';
import lokiWebpDesktop from './loki-desktop.webp';
import lokiJpgMobile from './loki-mobile.jpg';
import lokiWebpMobile from './loki-mobile.webp';

import lukeJpgDesktop from './luke-desktop.jpg';
import lukeWebpDesktop from './luke-desktop.webp';
import lukeJpgMobile from './luke-mobile.jpg';
import lukeWebpMobile from './luke-mobile.webp';

import lunaJpgDesktop from './luna-desktop.jpg';
import lunaWebpDesktop from './luna-desktop.webp';
import lunaJpgMobile from './luna-mobile.jpg';
import lunaWebpMobile from './luna-mobile.webp';

import macyAndLillyJpgDesktop from './macyandlilly-desktop.jpg';
import macyAndLillyWebpDesktop from './macyandlilly-desktop.webp';
import macyAndLillyJpgMobile from './macyandlilly-mobile.jpg';
import macyAndLillyWebpMobile from './macyandlilly-mobile.webp';

import maxJpgDesktop from './max-desktop.jpg';
import maxWebpDesktop from './max-desktop.webp';
import maxJpgMobile from './max-mobile.jpg';
import maxWebpMobile from './max-mobile.webp';

import mayJpgDesktop from './may-desktop.jpg';
import mayWebpDesktop from './may-desktop.webp';
import mayJpgMobile from './may-mobile.jpg';
import mayWebpMobile from './may-mobile.webp';

import miaJpgDesktop from './mia-desktop.jpg';
import miaWebpDesktop from './mia-desktop.webp';
import miaJpgMobile from './mia-mobile.jpg';
import miaWebpMobile from './mia-mobile.webp';

import mikaJpgDesktop from './mika-desktop.jpg';
import mikaWebpDesktop from './mika-desktop.webp';
import mikaJpgMobile from './mika-mobile.jpg';
import mikaWebpMobile from './mika-mobile.webp';

import mikeyJpgDesktop from './mikey-desktop.jpg';
import mikeyWebpDesktop from './mikey-desktop.webp';
import mikeyJpgMobile from './mikey-mobile.jpg';
import mikeyWebpMobile from './mikey-mobile.webp';

import mochiJpgDesktop from './mochi-desktop.jpg';
import mochiWebpDesktop from './mochi-desktop.webp';
import mochiJpgMobile from './mochi-mobile.jpg';
import mochiWebpMobile from './mochi-mobile.webp';

import oogieJpgDesktop from './oogie-desktop.jpg';
import oogieWebpDesktop from './oogie-desktop.webp';
import oogieJpgMobile from './oogie-mobile.jpg';
import oogieWebpMobile from './oogie-mobile.webp';

import oscarJpgDesktop from './oscar-desktop.jpg';
import oscarWebpDesktop from './oscar-desktop.webp';
import oscarJpgMobile from './oscar-mobile.jpg';
import oscarWebpMobile from './oscar-mobile.webp';

import riverJpgDesktop from './river-desktop.jpg';
import riverWebpDesktop from './river-desktop.webp';
import riverJpgMobile from './river-mobile.jpg';
import riverWebpMobile from './river-mobile.webp';

import rockyJpgDesktop from './rocky-desktop.jpg';
import rockyWebpDesktop from './rocky-desktop.webp';
import rockyJpgMobile from './rocky-mobile.jpg';
import rockyWebpMobile from './rocky-mobile.webp';

import simba1JpgDesktop from './simba-1-desktop.jpg';
import simba1WebpDesktop from './simba-1-desktop.webp';
import simba1JpgMobile from './simba-1-mobile.jpg';
import simba1WebpMobile from './simba-1-mobile.webp';

import simbaJpgDesktop from './simba-desktop.jpg';
import simbaWebpDesktop from './simba-desktop.webp';
import simbaJpgMobile from './simba-mobile.jpg';
import simbaWebpMobile from './simba-mobile.webp';

import treJpgDesktop from './tre-desktop.jpg';
import treWebpDesktop from './tre-desktop.webp';
import treJpgMobile from './tre-mobile.jpg';
import treWebpMobile from './tre-mobile.webp';

import unoJpgDesktop from './uno-desktop.jpg';
import unoWebpDesktop from './uno-desktop.webp';
import unoJpgMobile from './uno-mobile.jpg';
import unoWebpMobile from './uno-mobile.webp';

import vivienneKissesJpgDesktop from './viviennekisses-desktop.jpg';
import vivienneKissesWebpDesktop from './viviennekisses-desktop.webp';
import vivienneKissesJpgMobile from './viviennekisses-mobile.jpg';
import vivienneKissesWebpMobile from './viviennekisses-mobile.webp';

import winnieJpgDesktop from './winnie-desktop.jpg';
import winnieWebpDesktop from './winnie-desktop.webp';
import winnieJpgMobile from './winnie-mobile.jpg';
import winnieWebpMobile from './winnie-mobile.webp';

import winstonAndGusJpgDesktop from './winstonandgus-desktop.jpg';
import winstonAndGusWebpDesktop from './winstonandgus-desktop.webp';
import winstonAndGusJpgMobile from './winstonandgus-mobile.jpg';
import winstonAndGusWebpMobile from './winstonandgus-mobile.webp';

export const aslanSources = {
  desktop: {
    webP: aslanWebpDesktop,
    jpg: aslanJpgDesktop,
  },
  mobile: {
    webP: aslanWebpMobile,
    jpg: aslanJpgMobile,
  },
};

export const busterSources = {
  desktop: {
    webP: busterWebpDesktop,
    jpg: busterJpgDesktop,
  },
  mobile: {
    webP: busterWebpMobile,
    jpg: busterJpgMobile,
  },
};

export const candySources = {
  desktop: {
    webP: candyWebpDesktop,
    jpg: candyJpgDesktop,
  },
  mobile: {
    webP: candyWebpMobile,
    jpg: candyJpgMobile,
  },
};

export const charleySources = {
  desktop: {
    webP: charleyWebpDesktop,
    jpg: charleyJpgDesktop,
  },
  mobile: {
    webP: charleyWebpMobile,
    jpg: charleyJpgMobile,
  },
};

export const duncanSources = {
  desktop: {
    webP: duncanWebpDesktop,
    jpg: duncanJpgDesktop,
  },
  mobile: {
    webP: duncanWebpMobile,
    jpg: duncanJpgMobile,
  },
};

export const elvisSources = {
  desktop: {
    webP: elvisWebpDesktop,
    jpg: elvisJpgDesktop,
  },
  mobile: {
    webP: elvisWebpMobile,
    jpg: elvisJpgMobile,
  },
};

export const francisSources = {
  desktop: {
    webP: francisWebpDesktop,
    jpg: francisJpgDesktop,
  },
  mobile: {
    webP: francisWebpMobile,
    jpg: francisJpgMobile,
  },
};

export const gabiSources = {
  desktop: {
    webP: gabiWebpDesktop,
    jpg: gabiJpgDesktop,
  },
  mobile: {
    webP: gabiWebpMobile,
    jpg: gabiJpgMobile,
  },
};

export const ghostSources = {
  desktop: {
    webP: ghostWebpDesktop,
    jpg: ghostJpgDesktop,
  },
  mobile: {
    webP: ghostWebpMobile,
    jpg: ghostJpgMobile,
  },
};

export const gingerSources = {
  desktop: {
    webP: gingerWebpDesktop,
    jpg: gingerJpgDesktop,
  },
  mobile: {
    webP: gingerWebpMobile,
    jpg: gingerJpgMobile,
  },
};

export const gretaSources = {
  desktop: {
    webP: gretaWebpDesktop,
    jpg: gretaJpgDesktop,
  },
  mobile: {
    webP: gretaWebpMobile,
    jpg: gretaJpgMobile,
  },
};

export const jacSources = {
  desktop: {
    webP: jacWebpDesktop,
    jpg: jacJpgDesktop,
  },
  mobile: {
    webP: jacWebpMobile,
    jpg: jacJpgMobile,
  },
};

export const jaxSources = {
  desktop: {
    webP: jaxWebpDesktop,
    jpg: jaxJpgDesktop,
  },
  mobile: {
    webP: jaxWebpMobile,
    jpg: jaxJpgMobile,
  },
};

export const kennySources = {
  desktop: {
    webP: kennyWebpDesktop,
    jpg: kennyJpgDesktop,
  },
  mobile: {
    webP: kennyWebpMobile,
    jpg: kennyJpgMobile,
  },
};

export const kimberSources = {
  desktop: {
    webP: kimberWebpDesktop,
    jpg: kimberJpgDesktop,
  },
  mobile: {
    webP: kimberWebpMobile,
    jpg: kimberJpgMobile,
  },
};

export const kodaSources = {
  desktop: {
    webP: kodaWebpDesktop,
    jpg: kodaJpgDesktop,
  },
  mobile: {
    webP: kodaWebpMobile,
    jpg: kodaJpgMobile,
  },
};

export const loki1Sources = {
  desktop: {
    webP: loki1WebpDesktop,
    jpg: loki1JpgDesktop,
  },
  mobile: {
    webP: loki1WebpMobile,
    jpg: loki1JpgMobile,
  },
};

export const lokiSources = {
  desktop: {
    webP: lokiWebpDesktop,
    jpg: lokiJpgDesktop,
  },
  mobile: {
    webP: lokiWebpMobile,
    jpg: lokiJpgMobile,
  },
};

export const lukeSources = {
  desktop: {
    webP: lukeWebpDesktop,
    jpg: lukeJpgDesktop,
  },
  mobile: {
    webP: lukeWebpMobile,
    jpg: lukeJpgMobile,
  },
};

export const lunaSources = {
  desktop: {
    webP: lunaWebpDesktop,
    jpg: lunaJpgDesktop,
  },
  mobile: {
    webP: lunaWebpMobile,
    jpg: lunaJpgMobile,
  },
};

export const macyAndLillySources = {
  desktop: {
    webP: macyAndLillyWebpDesktop,
    jpg: macyAndLillyJpgDesktop,
  },
  mobile: {
    webP: macyAndLillyWebpMobile,
    jpg: macyAndLillyJpgMobile,
  },
};

export const maxSources = {
  desktop: {
    webP: maxWebpDesktop,
    jpg: maxJpgDesktop,
  },
  mobile: {
    webP: maxWebpMobile,
    jpg: maxJpgMobile,
  },
};

export const maySources = {
  desktop: {
    webP: mayWebpDesktop,
    jpg: mayJpgDesktop,
  },
  mobile: {
    webP: mayWebpMobile,
    jpg: mayJpgMobile,
  },
};

export const miaSources = {
  desktop: {
    webP: miaWebpDesktop,
    jpg: miaJpgDesktop,
  },
  mobile: {
    webP: miaWebpMobile,
    jpg: miaJpgMobile,
  },
};

export const mikaSources = {
  desktop: {
    webP: mikaWebpDesktop,
    jpg: mikaJpgDesktop,
  },
  mobile: {
    webP: mikaWebpMobile,
    jpg: mikaJpgMobile,
  },
};

export const mikeySources = {
  desktop: {
    webP: mikeyWebpDesktop,
    jpg: mikeyJpgDesktop,
  },
  mobile: {
    webP: mikeyWebpMobile,
    jpg: mikeyJpgMobile,
  },
};

export const mochiSources = {
  desktop: {
    webP: mochiWebpDesktop,
    jpg: mochiJpgDesktop,
  },
  mobile: {
    webP: mochiWebpMobile,
    jpg: mochiJpgMobile,
  },
};

export const oogieSources = {
  desktop: {
    webP: oogieWebpDesktop,
    jpg: oogieJpgDesktop,
  },
  mobile: {
    webP: oogieWebpMobile,
    jpg: oogieJpgMobile,
  },
};

export const oscarSources = {
  desktop: {
    webP: oscarWebpDesktop,
    jpg: oscarJpgDesktop,
  },
  mobile: {
    webP: oscarWebpMobile,
    jpg: oscarJpgMobile,
  },
};

export const riverSources = {
  desktop: {
    webP: riverWebpDesktop,
    jpg: riverJpgDesktop,
  },
  mobile: {
    webP: riverWebpMobile,
    jpg: riverJpgMobile,
  },
};

export const rockySources = {
  desktop: {
    webP: rockyWebpDesktop,
    jpg: rockyJpgDesktop,
  },
  mobile: {
    webP: rockyWebpMobile,
    jpg: rockyJpgMobile,
  },
};

export const simba1Sources = {
  desktop: {
    webP: simba1WebpDesktop,
    jpg: simba1JpgDesktop,
  },
  mobile: {
    webP: simba1WebpMobile,
    jpg: simba1JpgMobile,
  },
};

export const simbaSources = {
  desktop: {
    webP: simbaWebpDesktop,
    jpg: simbaJpgDesktop,
  },
  mobile: {
    webP: simbaWebpMobile,
    jpg: simbaJpgMobile,
  },
};

export const treSources = {
  desktop: {
    webP: treWebpDesktop,
    jpg: treJpgDesktop,
  },
  mobile: {
    webP: treWebpMobile,
    jpg: treJpgMobile,
  },
};

export const unoSources = {
  desktop: {
    webP: unoWebpDesktop,
    jpg: unoJpgDesktop,
  },
  mobile: {
    webP: unoWebpMobile,
    jpg: unoJpgMobile,
  },
};

export const vivienneKissesSources = {
  desktop: {
    webP: vivienneKissesWebpDesktop,
    jpg: vivienneKissesJpgDesktop,
  },
  mobile: {
    webP: vivienneKissesWebpMobile,
    jpg: vivienneKissesJpgMobile,
  },
};

export const winnieSources = {
  desktop: {
    webP: winnieWebpDesktop,
    jpg: winnieJpgDesktop,
  },
  mobile: {
    webP: winnieWebpMobile,
    jpg: winnieJpgMobile,
  },
};

export const winstonAndGusSources = {
  desktop: {
    webP: winstonAndGusWebpDesktop,
    jpg: winstonAndGusJpgDesktop,
  },
  mobile: {
    webP: winstonAndGusWebpMobile,
    jpg: winstonAndGusJpgMobile,
  },
};
